import {
  InfoModule,
  createInfoServices
} from "./chunk-4YFB5VUC.mjs";
import "./chunk-Y27MQZ3U.mjs";
export {
  InfoModule,
  createInfoServices
};
